var render = function render(_c,_vm){return _c('div',[_c('a',{class:{ Rojo: _vm.props.row.ToTal_ClientPayment < 0 },attrs:{"href":"#"},on:{"click":function($event){return _vm.$options.show(_vm.props)}}},[_vm._v(_vm._s(_vm.$options.formatMonto(_vm.props.row.ToTal_ClientPayment)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }